import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import CssBaseline from '@material-ui/core/CssBaseline';

import ContextProvider from '../../contexts/ContextProvider';

import ComponentLoader from '../../components/ComponentLoader';

import { FontStyles, GlobalStyle } from './styled';

const Careers = React.lazy(() => import('../../scenes/Careers'));
const Farms = React.lazy(() => import('../../scenes/Farms'));
const Index = React.lazy(() => import('../../scenes/Index'));
const OurStory = React.lazy(() => import('../../scenes/OurStory'));
const PrivacyPolicy = React.lazy(() => import('../../scenes/PrivacyPolicy'));
const ProgrammingMenu = React.lazy(() => import('../../scenes/ProgrammingMenu'));
const Retreats = React.lazy(() => import('../../scenes/Retreats'));

export default function App() {
  return (
    <ContextProvider>
      <FontStyles />
      <CssBaseline />
      <GlobalStyle />
      <React.Suspense fallback={<ComponentLoader />}>
        <Switch>
          <Route path="/" component={Index} exact />
          <Route path="/careers" component={Careers} />
          <Route path="/farms" component={Farms} />
          <Route path="/our-story" component={OurStory} />
          <Route path="/privacy-policy" component={PrivacyPolicy} />
          <Route path="/programming/:slug" component={ProgrammingMenu} />
          <Route path="/retreats" component={Retreats} />
        </Switch>
      </React.Suspense>
    </ContextProvider>
  );
}
